require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/core-js/library/fn/get-iterator.js
 ** module id = 923
 ** module chunks = 0
 **/